import { API } from '../../utils/amplifyWrapper';
import { useQuery } from "@tanstack/react-query";

const fetchLanguagesBase = async (includeLegacy: boolean) => {
    const url = includeLegacy ? `/voices?include_deprecated=true` : `/voices`;
    const response = await API.get('main', url, {headers: {'Content-Type': "application/json"}});
    const data = JSON.parse(response.data);

    if (typeof window !== 'undefined') {
        if (includeLegacy) {
            // Legacy cache includes deprecated providers (e.g. Azure) — used by the
            // editor saga when the current block's voice is from a deprecated provider.
            (window as any).__LANGUAGES_CACHE_LEGACY__ = data;
        } else {
            (window as any).__LANGUAGES_CACHE__ = data;
        }
    }

    return data;
};

export const fetchLanguages = () => fetchLanguagesBase(false);

export const useLanguages = (onSuccess?: (data: any) => void, opts?: { legacy?: boolean }) => {
    const legacy = opts?.legacy ?? false;
    return useQuery(
        legacy ? ['languages', 'legacy'] : ['languages'],
        () => fetchLanguagesBase(legacy),
        { onSuccess, refetchOnWindowFocus: false }
    );
}
